const ownershipTypeHelpTextMap = {
  USUF: 'The person is ...', // this is literally quoted from the SRD2 docs... (?)
  OWNR: 'A person has full ownership on the asset',
  BOWN: 'A person has bare ownership on the asset',
};

export default function (ownershipTypeEnum) {
  return ownershipTypeHelpTextMap[ownershipTypeEnum];
}
